<template>
  <div id="orderListDetai" ref="orderListDetai">
    <div class="detail_more" v-show="detailMoreShow">
      <van-loading class="detail_more_img" color="#c41335" type="spinner" size="24px" />
    </div>

    <div class="title">
      <p class="name">订单详情<span class="back" @click="back()" v-if="isApp!==2">返回<i class="backIcon">></i></span></p>
    </div>
    <div class="status">
      <p class="state">
        {{detail.order.delivery_method&&detail.order.delivery_method==1?userOrderStatus:orderStatus}}
      </p>
      <p v-if="orderStatus !== '交易关闭'&&userOrderStatus !== '交易关闭'" class="lastTime">
        <template v-if="detail.order.delivery_method==1"><!--自提-->
            <template v-if="userOrderStatus=='待付款'">
                {{'还剩'+lastTime+'自动取消订单'}}
            </template>
            <template v-if="userOrderStatus=='待提货'||userOrderStatus=='已完成'">
              提货码: {{detail.order.delivery_code}}
            </template>
        </template>
        <template v-else><!--邮寄-->
            {{orderStatus === '待付款'?'还剩'+lastTime+'自动取消订单':
              (orderStatus === '待发货'?'请耐心等待我们会尽快发货！':(orderStatus === '待收货'? '还剩'+lastTime+'自动确认收货':''))}}
        </template>
      </p>
    </div>
    <div class="detail" :style="{paddingTop:pd + 'px'}">
        <div class="floating" ref="floating" v-if="detail.order.delivery_method&&detail.order.delivery_method==1"><!--自提-->
          <div class="info">
            <div class="leftbox">
              <div class="img"></div>
            </div>
            <div class="rightbox">
              <p class="receiverName">{{detail.customStore.name}}<span class="phone">{{detail.customStore.phone}}</span></p>
              <p class="address">{{detail.customStore.province + detail.customStore.area + detail.customStore.address}}</p>
              <p class="shop_hours">营业时间: {{detail.customStore.shop_hours}}</p>
            </div>
          </div>

        </div>
        <div class="floating" ref="floating" v-if="!detail.order.delivery_method || detail.order.delivery_method==2">
        <div class="info">
          <div class="leftbox">
            <div class="img"></div>
          </div>
          <div class="rightbox">
            <p class="receiverName">{{detail.receiver}}<span class="phone">{{detail.order.user_phone}}</span></p>
            <p class="address">{{detail.province_city_area + detail.detail_address}}</p>
          </div>
        </div>
        <div class="freight" v-if="(orderStatus === '待收货'||orderStatus === '已完成')">
          <div class="leftbox">
                <div class="img"></div>
              </div>
              <div class="rightbox">
                <p class="freightCompany">快递公司:<span class="phone">{{detail.send[0]?detail.send[0].express_name:""}}</span></p>
                <p class="freightNumber">物流单号:<span class="Number">{{detail.send[0]?detail.send[0].express_number:""}}</span></p>
              </div>
          </div>

      </div>

      <div class="itemList">
        <div class="detailItem" v-for="(item,index) in itemList" :key="item.id"
          @click.stop.prevent="ckeckItem(item.goods_id)">
          <img :src="item.coverimg" alt="" class="itemImg">
          <div class="itemDetail">
            <div class="leftPart">
              <p class="itemName">{{item.product_name}}</p>
              <p class="specs">{{item.spec_detail}}</p>
            </div>
            <div class="rightPart">
              <p class="price">￥{{item.unit_prices}}</p>
              <p class="numb">X{{item.number}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="priceArea">
        <p class="freight">商品总价<span class="price">￥{{discountNumber?FenToYuan(parseInt(total)*100+parseInt(discountNumber)*100):total}}</span></p>
        <p class="freight">运费<span class="price">￥{{freightPrice}}</span></p>
        <p class="freight freight_you">活动优惠<span class="price">￥{{discountNumber?discountNumber:0}}</span></p>
        <p class="total">￥{{total}}<span class="price">总计</span></p>
      </div>
    </div>
    <div class="orderDetail">
      <p class="innertitle">订单信息</p>
      <p class="orderInner"><span class="in">订单号</span>{{orderId}}</p>
      <p class="orderInner" v-if="detail.order.channel">
        <!-- <span class="in">支付方式</span>{{detail.order.channel === 'remittance'?'线下汇款':(detail.order.channel === 'alipay'?'支付宝':(detail.order.channel === 'wx'?'微信':''))}} -->
        <span class="in">支付方式</span>
          {{ moneyState(detail.order.channel) }}
      </p>
      <p class="orderInner" v-if="detail.order.payment_transaction_number"><span
          class="in">支付交易号</span>{{detail.order.payment_transaction_number}}</p>
      <p class="orderInner"><span class="in">订单时间</span>{{createTime}}</p>
      <!-- <p class="orderInner" v-if="detail.order.promotion_code&&detail.order.promotion_code!==''"><span class="in">优惠码</span>{{detail.order.promotion_code}}</p> -->
      <p class="orderInner" v-if="payTime !== ''"><span class="in">付款时间</span>{{payTime}}</p>
      <p class="orderInner"><span class="in">运送方式</span>{{detail.order.delivery_method&&detail.order.delivery_method==1?"自提":"普通配送"}}</p>
      <p class="orderInner" style="display:flex;"><span class="in">订单备注</span><span class="in_l">{{detail.order.leave_word}}</span></p>

    </div>
    <div class="buttonPart" :style="{marginBottom:tabHeight + 'px'}"
      v-if="orderStatus === '待付款' && detail.order.channel !== 'remittance'">
      <span class="btn" v-if="detail.order.delivery_method==2" @click="changeAddr(detail)">修改地址</span>
      <span class="btn" v-if="detail.order.delivery_method==1" @click="changeAddrzx(detail)">更换门店</span>
      <span class="btn red" @click="del(orderId)">删除订单</span>
      <span class="btn active" @click="submit(orderId, total)">立即付款</span>
    </div>
    <div class="buttonPart" v-if="orderStatus === '待付款' && detail.order.channel === 'remittance'"  :style="{marginBottom:tabHeight + 'px'}">
      <p class="orderState">汇款审核中</p>
    </div>
    <div class="buttonPart" v-if="orderStatus === '待发货'"  :style="{marginBottom:tabHeight + 'px'}">
      <span class="btn" @click="al_goods(orderId)">提醒发货</span>
      <span v-if="detail.order.invoice_state==='未申请'" class="btn" @click="reciveBill(orderId)">申请发票</span>
      <span v-else-if="detail.order.invoice_state==='已申请'" class="btn btn_no" @click.stop.prevent="">已申请</span>
      <span v-else-if="detail.order.invoice_state==='已开具'" class="btn" @click.stop.prevent="goToInvoice(orderId)">查看发票</span>

      <span v-if="detail.mallOrderDoc.status === 0" class="btn"
                @click.stop.prevent="downLoadHeTong(detail.mallOrderDoc.order_id)">下载合同</span>
      <span v-else-if="detail.mallOrderDoc.status === 1" class="btn"
                @click.stop.prevent="checkHeTong(detail.mallOrderDoc.order_id)">查看合同</span>
    </div>
    <div class="buttonPart" v-if="orderStatus ===  '待收货'" :style="{marginBottom:tabHeight + 'px'}">
      <!-- <span class="btn" @click="goinfo(orderId)">查看物流</span> -->
      <span v-if="detail.order.invoice_state==='未申请'" class="btn" @click="reciveBill(orderId)">申请发票</span>
      <span v-else-if="detail.order.invoice_state==='已申请'" class="btn btn_no" @click.stop.prevent="">已申请</span>
      <span v-else-if="detail.order.invoice_state==='已开具'" class="btn" @click.stop.prevent="goToInvoice(orderId)">查看发票</span>
      <!-- <span v-else-if="detail.order.invoice_state === '已申请'" class="btn grey">已申请</span>
      <span v-else-if="detail.order.invoice_state === '已开具'" class="btn grey">已开票</span> -->
      <span class="btn active" v-if="!(detail.order.delivery_method&&detail.order.delivery_method==1)" @click="confirmshop(orderId)">确认收货</span>
      <span v-if="detail.mallOrderDoc.status === 0" class="btn"
                @click.stop.prevent="downLoadHeTong(detail.mallOrderDoc.order_id)">下载合同</span>
      <span v-else-if="detail.mallOrderDoc.status === 1" class="btn"
                @click.stop.prevent="checkHeTong(detail.mallOrderDoc.order_id)">查看合同</span>
    </div>
    <div class="buttonPart" v-if="orderStatus ===  '已完成'" :style="{marginBottom:tabHeight + 'px'}">
      <span v-if="detail.order.invoice_state==='未申请'" class="btn" @click="reciveBill(orderId)">申请发票</span>
      <span v-else-if="detail.order.invoice_state==='已申请'" class="btn btn_no" @click.stop.prevent="">已申请</span>
      <span v-else-if="detail.order.invoice_state==='已开具'" class="btn" @click.stop.prevent="goToInvoice(orderId)">查看发票</span>
      <span v-if="detail.mallOrderDoc.status === 0" class="btn"
                @click.stop.prevent="downLoadHeTong(detail.mallOrderDoc.order_id)">下载合同</span>
      <span v-else-if="detail.mallOrderDoc.status === 1" class="btn"
                @click.stop.prevent="checkHeTong(detail.mallOrderDoc.order_id)">查看合同</span>
    </div>
    <!-- <payView type="5" :money="orderamount" :orderId="orderId" :show="payViewVisible" @payValue="payValue"></payView> -->
    <!--  支付成功弹窗  -->
    <!-- <SuccessView :show="showSuccessView" type="2" @successViewClick="successViewClick"></SuccessView> -->
    <div class="mask" v-if="masker || maskerSure || changeAddress"></div>
    <div class="makeSure" v-if="masker">
      <!-- <div class="cssPopTitle">
        <p>提示</p>
      </div> -->
      <div class="cssPopBody">
        <!-- <p class="cssWranningtext"><span class="cssWranning">!</span>此操作将删除该项目，是否继续？</p> -->
        <p class="cssWranningtext">确认删除订单？</p>
        <div class="cssBottombutton">
          <button @click="hideDelPop()" class="cssButtonCommon white">再想想</button>
          <button @click="delFun(orderId)" class="cssButtonCommon">确定删除</button>
        </div>
      </div>
    </div>
    <div class="makeSure" v-if="maskerSure">
      <!-- <div class="cssPopTitle">
        <p>提示</p>
      </div> -->
      <div class="cssPopBody sure">
        <!-- <p class="cssWranningtext"><span class="cssWranning">!</span>请确认是否已收到货物</p> -->
        <p class="cssWranningtext bold">确认收到货了？</p>
        <p class="cssWranningtext sub">为保障您的权益，请收到货确认无误后，再确认收货哦！</p>
        <div class="cssBottombutton">
          <button @click="hideSurePop()" class="cssButtonCommon white">取消</button>
          <button @click="Sure(orderId)" class="cssButtonCommon">确认收货</button>
        </div>
      </div>
    </div>
    <div class="makeSure change" v-if="changeAddress">
      <div class="cssPopTitle">
        <p>修改地址信息</p>
      </div>
      <div class="cssPopBody">
        <form class="form" action="">
          <div class="inner">
            <span>收货人：</span><input type="text" maxlength="20" :placeholder="address.receiver" v-model="form.receiver">
          </div>
          <div class="inner">
            <span>收货人手机号：</span><input type="text" maxlength="11" :placeholder="address.user_phone"
              v-model="form.user_phone" oninput="value=value.replace(/[^\d]/g,'')">
          </div>
          <div class="inner">
            <span>地址信息：</span><input type="text" maxlength="30" disabled :placeholder="address.province_city_area"
              v-model="form.province_city_area" @click="changeAddre">
          </div>
          <div class="inner">
            <span>详细地址：</span><textarea type="text" maxlength="50" :placeholder="address.detail_address"
              v-model="form.detail_address"></textarea>
          </div>
        </form>
        <div class="submit">
          <span class="submitBtn cancel" @click="cancle()">取消</span>
          <span class="submitBtn" @click="sub(form)">修改</span>
        </div>
      </div>
    </div>
    <mt-popup v-model="show" :closeOnClickModal="0" position="bottom" class="pay-popup">
      <div class="header" @click="cancelClick">
        <div class="close"></div>
        <div class="tip">{{title}}</div>
      </div>
      <div class="pay-money pay-money4">
        <div class="money">
          ￥{{totalAmount}}
        </div>
      </div>
      <div class="pay-type" :style="{marginBottom: tabHeight+'px'}">
        <div v-if="!iswx">
          <div class="pay-box" v-for="(value, index) in items" :key="value.id"
            @click="selPayTypeClick(1,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
        <div v-if="iswx">
          <div class="pay-box" v-for="(value, index) in items2" :key="value.id"
            @click="selPayTypeClick(2,value,value.id)">
            <img class="icon" :src="value.image" />
            <div>{{value.title}}</div>
            <img class="select" :id="forId(index)" :src="value.isSel?msgImg_s:msgImg_n" />
          </div>
        </div>
      </div>
      <div class="bottom" :style="{marginBottom: tabHeight+'px'}">
        <div class="apply" @click="surePayClick" :style="{backgroundColor:activeStyle}">确认支付</div>
      </div>
      <!-- H5支付form表单 -->
      <div v-html="htmlForm"></div>
    </mt-popup>
    <AreaView :show="showAddress" @selectedArea="selectedArea"></AreaView>
    <van-action-sheet v-model="changeShopShow"  title="更换门店" @close="closeSheet" :round=false>
      <changeShop @changeShopDetail="changeShopDetail" :clickItemDetail="detail.order"></changeShop>
    </van-action-sheet>
  </div>
</template>

<script>
import AreaView from '../../../components/area-view'
// import payView from '../../../components/shopCenterPay'
import { Toast } from 'mint-ui'
// import SuccessView from '../../../components/success-view'
import wxshare from '../../../wx/weixin'
import changeShop from '../../../components/changeShop.vue'
import { mapState } from 'vuex'
export default {
  inject: ['reload'],
  computed: {
    ...mapState({
      // reloadOrderId: 'MallOrderId',
      oldOrderId: 'oldOrderId'
    }),
    isActive () {
      if (this.payIndex > 0) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    // payView,
    // SuccessView,
    AreaView, changeShop
  },
  watch: {
    isActive: function (val) {
      if (val === true) {
        this.activeStyle = '#C41335'
      } else {
        this.activeStyle = '#FECDCD'
      }
    }
  },
  data () {
    return {
      isApp: 0,
      show: false,
      total: 0,
      totalAmount: 0,
      title: '支付金额',
      items: [
        { id: '1', title: '支付宝支付', image: require('../../../assets/icon_pay_alipay.png'), isSel: 0 },
        { id: '2', title: '微信支付', image: require('../../../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../../../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      items2: [
        { id: '2', title: '微信支付', image: require('../../../assets/icon_pay_wx.png'), isSel: 0 },
        { id: '3', title: '银行汇款', image: require('../../../assets/icon_pay_bank.png'), isSel: 0 }
      ],
      payType: '',
      payIndex: 0,
      payInfo: {
        id: ''
      },
      msgImg_n: require('../../../assets/radio_n.png'),
      msgImg_s: require('../../../assets/radio_s.png'),
      iswx: false,
      payOrderId: '',
      tabHeight: '0',
      activeStyle: '#FECDCD',
      htmlForm: '',
      masker: false,
      showAddress: false,
      payViewVisible: false,
      showSuccessView: false,
      changeAddress: false,
      maskerSure: false,
      orderamount: '',
      orderId: this.$route.query.orderId,
      lastTime: '',
      orderStatus: '',
      userOrderStatus: '', // 用户自提状态
      detail: {
        order: {
          user_phone: ''
        }
      },
      itemList: [],
      total: Number,
      freightPrice: Number,
      discountNumber:null,//优惠价格
      pd: Number,
      createTime: '',
      payTime: '',
      form: {
        area: '',
        city: '',
        detail_address: '',
        orderId: '',
        province: '',
        province_city_area: '',
        receiver: '',
        user_phone: ''
      },
      address: [
        {
          user_phone: ''
        }
      ],
      changeShopShow: false,
      clickItemDetail: '', // 点击更换门店订单信息
      detailMoreShow: true
    }
  },
  methods: {
    moneyState (comm) {
      if (comm == 'alipay_pc_direct') {
        return '支付宝/电脑'
      } else if (comm == 'wx_pub_qr') {
        return '微信/电脑'
      } else if (comm == 'alipay') {
        return '支付宝/app'
      } else if (comm == 'wx') {
        return '微信/app'
      } else if (comm == 'alipay_wap') {
        return '支付宝/H5'
      } else if (comm == 'wx_wap') {
        return '微信/H5'
      } else if (comm == 'wx_jsapi') {
        return '微信/公众号'
      } else if (comm == 'remittance') {
        return '线下汇款'
      } else {
        return '其他方式'
      }
    },
    goToInvoice (id) {
      this.$router.push({
        path: '/invoiceDetail',
        query: {
          orderId: id
        }
      })
    },
    checkHeTong (id) {
      window.open(this.cdn + id)
    },
    downLoadHeTong (id) {
      let src = this.companyUrl + '/zxOrder/downSalesContract?orderId=' + id
      let a = document.createElement('a')
      a.href = src
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    changeAddrzx (item) {
      console.log('点击更换门店:', item)
      this.changeShopShow = true
    },
    closeSheet () {
      this.changeShopShow = false
    },

    changeShopDetail (item) {
      this.utils.post(this.companyUrl + '/zxOrder/changeCustomStore', {
        orderId: this.detail.order.id,
        customShopId: JSON.parse(item).id
      }, res => {
        console.log('zxOrder/changeCustomStore:,', res)
        this.$message.success(res.message)
        this.changeShopShow = false
        this.getDetail()
      })
    },
    ckeckItem (id) {
      this.$router.push({
        path: '/goodsdetail',
        query: {
          goodsId: id,
          // 先写死, 都是中消自营的商品
          bussinessId: 26116
        }
      })
    },
    androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = this.tabHeight + parseInt(value)
      }
    },
    submit (id, amount) {
      this.totalAmount = amount
      this.payOrderId = id
      this.show = true
    },
    forId (index) {
      return 'selectImg' + index
    },
    selPayTypeClick (index, value, id) {
      // this.getOrderId()
      this.payIndex = parseInt(id)
      switch (this.payIndex) {
        case 1:
          // this.payType = 'alipay_pc_direct'
          this.payType = 'alipay_wap'
          break
        case 2:
          if (this.utils.isWX()) {
            this.payType = 'wx_jsapi'
          } else {
            this.payType = 'wx_wap'
          }
          break
        case 3:
          this.payType = 'remittance'
          break
      }
      if (index === 1) {
        this.items.forEach((item, index) => {
          item.isSel = 0
        })
      } else {
        this.items2.forEach((item, index) => {
          item.isSel = 0
        })
      }
      value.isSel = 1
    },
    cancelClick () {
      this.show = false
    },
    surePayClick () {
      if (this.isActive) {
        if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1) {
        // 消防云 中消商城  支付宝 微信支付  下单 支付
        // app 内嵌网页掉支付
          var enterType = localStorage.getItem('enterType')
          if (enterType === undefined || enterType === null) {
            enterType = 0
          } else {
            enterType = parseInt(enterType)
          }
          if (enterType === 1) { // app 内嵌网页掉支付
            if (this.payIndex === 3) { // 线下 审核汇款
              console.log('===================线下汇款')
              this.$router.push({ path: '/remittance', query: { orderID: this.orderId } })
            } else {
              if (this.utils.isIphone()) { // ios 支付
              // Toast('iOS -- app内嵌h5支付')
                window.webkit.messageHandlers.startPay.postMessage({
                  'payType': this.payType,
                  'orderId': this.orderId
                })
              } else {
              // Toast('Android -- app内嵌h5支付')
                console.log('Android startPay')
                window.zxzx.startPay(this.payType, this.orderId)
              }
              // 查询支付状态
              this.payState()
              console.log('payState')
            }
            return
          }
          return
        }

        if (this.utils.isWX()) {
          if (this.payType === 'wx_jsapi') {//微信支付
            if (localStorage.getItem('openId') !== null) {// 已经授权过有了openid
                this.toPay(this.orderId, localStorage.getItem('openId'))
                return false;
              } else {//去授权
                let redirectURI = encodeURIComponent(window.location.href)
                  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+this.appIdMall +
                  '&redirect_uri=' + redirectURI +
                  '&response_type=code&scope=snsapi_base&state=WXPaySTATE&connect_redirect=1#wechat_redirect'
              }
            }
        }

        if (this.payIndex === 3) {// 点击汇款
          this.$router.push({ path: '/remittance', query: { orderID: this.orderId } })
        } else {
          console.log('newPay')
          this.utils.post(this.companyUrl + '/newPay/' + this.payType + '/' + this.payOrderId, null, res => {
            let payUrl = res.data.payUrl
            if (payUrl.indexOf('http') === 0) { // 微信
              window.location.href = payUrl
            } else { // 支付宝
              this.htmlForm = payUrl
              setTimeout(function () {
                document.forms[0].submit()
              }, 500)
            }
          })
        }
      }
    },
    toDecimal2 (x) {
      console.log(x)
      var f = parseFloat(x)
      if (isNaN(f)) {
        return false
      }
      var E = Math.round(x * 100) / 100
      var s = E.toString()
      var rs = s.indexOf('.')
      if (rs < 0) {
        rs = s.length
        s += '.'
      }
      while (s.length <= rs + 2) {
        s += '0'
      }
      return s
    },

    FenToYuan (data) {
      let num = data
      num = data * 0.01
      num += ''
      let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g
      num = num.replace(reg, '$1')
      num = this.toDecimal2(num)
      return num
    },

    getDetail () {
      let obj = {
        orderId: this.orderId
      }
      this.utils.get(this.companyUrl + '/zxOrder/mallOrderDetail', obj, res => {
        this.detail = res.data
        this.clickItemDetail = res.data.order
        this.orderStatus = this.dealStatus(this.detail)
        if (this.detail.order.delivery_method && this.detail.order.delivery_method == 1) {
          this.userOrderStatus = this.userDealStatus(this.detail)
        }
        this.lastTime = this.dealDays(this.detail.order.create_time * 1000)
        this.itemList = this.detail.mallOrderDetail
        this.itemList.forEach((item, index) => {
          let str = ''
          let spec = JSON.parse(item.spec_detail)
          for (let key in spec) {
            str = str + key + ':' + spec[key] + ' '
          }
          item.spec_detail = str
        })
        if (this.detail.order.discount_number) {
          this.discountNumber = this.FenToYuan(this.detail.order.discount_number)
        }
        this.total = this.FenToYuan(parseInt(this.detail.order.amount))
        if (this.detail.order.delivery_method && this.detail.order.delivery_method == 2 && this.detail.order.promotion_code == '') { // 快递并且没有使用优惠码
          this.freightPrice = this.FenToYuan(this.detail.order.freight)
        } else {
          this.freightPrice = 0
        }
        this.createTime = this.utils.dealTime(this.detail.order.create_time)
        if (this.detail.order.pay_time) {
          this.payTime = this.utils.dealTime(this.detail.order.pay_time)
        }
        this.itemList.forEach((item, index) => {
          item.unit_prices = this.FenToYuan(item.unit_price)
          item.coverimg = item.product_cover.split(',')[0]
          // this.freightPrice = item.freight
        })

        setTimeout(() => {
          this.detailMoreShow = false
        }, 200)
      })
    },
    calPadding () {
      let domHeight = this.$refs.floating.clientHeight
      this.pd = domHeight
    },
    dealDays (beginTime) {
      let nowTime = new Date().getTime()
      let calTime = (beginTime + (15 * 1000 * 24 * 3600)) - nowTime
      let day = Math.floor(calTime / 86400000)
      let hour = Math.floor((calTime % (86400000)) / (3600 * 1000))
      return day + '天' + hour + '小时'
    },
    dealStatus (item) {
      let str = ''
      if (item.order.order_state === '失效') {
        str = '交易关闭'
      } else if (item.order.pay_state === '已退款') {
        str = '已退款'
      } else if (item.order.pay_state === '未付款' && item.order.channel !== 'remittance') {
        str = '待付款'
      } else if (item.order.pay_state === '未付款' && item.order.channel === 'remittance') {
        str = '待付款'
      } else if (item.order.pay_state === '已付款' && item.order.logistics_status === 1) {
        str = '待发货'
      } else if (item.order.pay_state === '已付款' && item.order.logistics_status === 2) {
        str = '待收货'
      } else if (item.order.pay_state === '已付款' && item.order.logistics_status === 3) {
        str = '已完成'
      }
      return str
    },
    userDealStatus (item) {
      let str = ''
      if (item.order.order_state === '失效') {
        str = '交易关闭'
      } else if (item.order.pay_state === '已退款') {
        str = '已退款'
      } else if (item.order.pay_state === '未付款' && item.order.channel !== 'remittance') {
        str = '待付款'
      } else if (item.order.pay_state === '未付款' && item.order.channel === 'remittance') {
        str = '待付款'
      } else if (item.order.pay_state === '已付款' && item.order.delivery_status == 0) {
        str = '待提货'
      } else if (item.order.pay_state === '已付款' && item.order.delivery_status == 1) {
        str = '已完成'
      }
      return str
    },
    logoutClick () {

    },
    changeAddr (item) {
      this.changeAddress = true
      this.address = item.mallOrderDetail[0]
      this.address.user_phone = item.order.user_phone
      this.form = this.address
    },
    changeAddrzx (item) {
      console.log('点击更换门店')
      this.changeShopShow = true
    },
    changeAddre () {
      this.showAddress = true
    },
    selectedArea: function (province, city, area, code) {
      this.showAddress = false
      if (province.length <= 0) {
        return
      }
      this.form.province = province
      this.form.city = city
      this.form.area = area
      this.form.province_city_area = province + ' ' + city + ' ' + area
    },
    reciveBill (id) {
      this.$router.push({
        path: '/billCenter',
        query: {
          billCenterType: 1,
          orderNo: id
        }
      })
    },
    cancle () {
      this.changeAddress = false
    },
    sub (form) {
      if (form.receiver === '') {
        Toast('请输入收货人姓名')
      } else if (form.user_phone === '') {
        Toast('请输入收货人手机号码')
      } else if (!this.utils.isPhone(form.user_phone)) {
        Toast('请输入正确的手机号')
        form.user_phone = ''
      } else if (form.province_city_area === '') {
        Toast('请选择收货地址')
      } else if (form.detail_address === '') {
        Toast('请输入详细收货地址')
      } else {
        form.orderId = this.orderId
        let obj = {
          area: form.area,
          city: form.city,
          detail_address: form.detail_address === '' ? this.address.detail_address : form.detail_address,
          orderId: form.orderId,
          province: form.province,
          province_city_area: form.province_city_area === '' ? this.address.province_city_area : form.province_city_area,
          receiver: form.receiver === '' ? this.address.receiver : form.receiver,
          user_phone: form.user_phone === '' ? this.address.user_phone : form.user_phone
        }
        this.utils.post(this.companyUrl + '/zxOrder/changeAddress', obj, res => {
          this.$message.success(res.message)
          this.changeAddress = false
          this.getDetail()
        })
      }
    },
    hideDelPop () {
      this.masker = false
    },
    delFun (id) {
      this.utils.POST(this.companyUrl + '/zxOrder/deleteOrder',
        {
          order_id: id
        },
        resj => {
          this.masker = false
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.$router.go(-1)
        }
      )
    },
    del () {
      this.masker = true
    },
    applyClick (id, amount) {
      this.$store.commit('storeOrderId', id)
      this.orderamount = amount
      this.payViewVisible = true
    },
    payValue: function (state) {
      if (state === 1) {
        this.showSuccessView = true
      }
      this.payViewVisible = false
    },
    successViewClick: function () {
      this.showSuccessView = false
      this.getDetail()
    },
    al_goods (id) {
      this.utils.POST(this.companyUrl + '/zxOrder/remindDelivery',
        {
          order_id: id
        },
        resj => {
          this.$message.success(resj.message)
        }
      )
    },
    confirmshop (id) {
      this.maskerSure = true
    },
    Sure (id) {
      this.utils.POST(this.companyUrl + '/zxOrder/confirmReceipt',
        {
          order_id: id
        },
        resj => {
          this.maskerSure = false
          this.$message.success(resj.message)
          this.getDetail()
        }
      )
    },
    hideSurePop () {
      this.maskerSure = false
    },
    back () {
      this.$store.commit('clearOrderId', '')
      this.$router.replace({
        path: '/orderListCenter',
        query: {
          status: 4,
          tag: 0
        }
      })
    },
    getopenId (code) {
      this.utils.post(this.companyUrl + '/newPay/getOpenId?code=' + code, null, res => {
        if (res.code === 0) {
          localStorage.setItem('openId', res.data)
          this.toPay(this.payOrderId, res.data)
        }
      })
    },
    onBridgeReady (data) {
      let param = data.payParams
      window.WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          'appId': param.appId, // 公众号名称，由商户传入
          'timeStamp': param.timeStamp, // 时间戳，自1970年以来的秒数
          'nonceStr': param.nonceStr, // 随机串
          'package': param.package,
          'signType': param.signType, // 微信签名方式：
          'paySign': param.paySign // 微信签名
        },
        res => {
          // if (res.err_msg === 'get_brand_wcpay_request:ok') {
          this.$store.commit('clearOrderId', '')
          window.location.href = 'https://m.zxzx119.com/orderListDetail?orderId=' + this.orderId
          // }
        })
    },
    launchWXPay(data) { // 微信浏览器发起微信支付 wx_jsapi
      console.log("launchWXPay:",data)
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(data), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(data))
          document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(data))
        }
      } else {
        this.onBridgeReady(data)
      }
    },
    toPay (orderid, openId) {
      this.utils.post(this.companyUrl + '/newPay/wx_jsapi/' + orderid + '?openId=' + openId, null, res => {
        console.log(res)
        if (res.code === 0) {
          this.launchWXPay(res.data)
        }
      })
    },
    paySuccess (state) {
      if (state === '0') {
        // 支付成功，跳转至订单列表
        this.$store.commit('clearOrderId', '')
        this.reload()
      }
    },
    WX () {
      let ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    }

  },
  created () {
    if (this.$route.query.isApp) {
      this.isApp = parseInt(this.$route.query.isApp)
      localStorage.setItem('isApp', parseInt(this.$route.query.isApp))
      if (this.isApp === 2) {
        this.utils.GET(this.companyUrl + '/ent/json',
          function (res) {
            localStorage.setItem('userinfo', JSON.stringify(res.data))
          })
      }
    } else if (parseInt(localStorage.getItem('isApp'))) {
      this.isApp = parseInt(localStorage.getItem('isApp'))
    }
    if (this.$route.query.orderId && this.$route.query.orderId !== '') {
      this.orderId = this.$route.query.orderId
    } else {
      if (this.oldOrderId !== '') {
        this.orderId = this.oldOrderId
      } else {
        this.$router.replace({
          path: '/orderListCenter',
          query: {
            status: 4,
            tag: 0
          }
        })
      }
    }
    this.getDetail()
  },
  updated () {
    this.calPadding()
  },
  mounted () {
    let _this = this
    window['paySuccess'] = (result) => {
      _this.paySuccess(result)
    }
    this.iswx = this.WX()
    this.payOrderId = this.$route.query.orderId;
    wxshare.wxShareHomePage('【中消在线】消防安全产品一站式采购平台', '品质保障，正品低价，支持线上交易', 'http://cdn.zxzx119.com/1294196519632633856')
    if (this.utils.isWX()) {
      if (this.$route.query.code !== undefined && localStorage.getItem('openId') === null) {
        // 首次授权重定向
        this.getopenId(this.$route.query.code)
      } else if (localStorage.getItem('openId') !== null && this.$route.query.code !== undefined) {
        // 授权后再次进入 or 授权后首次进入
        let opId = localStorage.getItem('openId')
        if (this.payOrderId !== undefined ) {
          this.toPay(this.payOrderId, opId)
        }
      }
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 ||
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#orderListDetai {
  width: 100%;
  height: 100vh;
  background: #f6f4f5;
  .detail_more{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    bottom: 0;
    right: 0;
    background: #ffffff;
    .detail_more_img{
      position:absolute;
      top:calc(50% - 12px);
      left: calc(50% - 12px);
    }
  }
}
.title {
  height: 50px;
  line-height: 50px;
  padding: 0 16.5px 0 14px;
  background: #ffffff;
  .name {
    font-size: 15px;
    color: #000000;
    font-weight: bold;
    .back {
      float: right;
      font-size: 13px;
      color: #999999;
      .backIcon {
        display: inline-block;
        vertical-align: top;
        margin-left: 5px;
        font-size: 13px;
        color: #999999;
        font-style: inherit;
      }
    }
  }
}
.status {
  width: 100%;
  height: 120px;
  background: #c41335 url("images/box.png") no-repeat bottom right;
  background-size: 85px 90px;
  padding: 27.5px 0 0 14.5px;
  .state {
    font-size: 24px;
    font-weight: bold;
    color: #ffffff;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .lastTime {
    font-size: 14px;
    color: #ffffff;
    line-height: 14px;
    margin-bottom: 18px;
  }
}
.detail {
  width: 100%;
  background: #ffffff;
  position: relative;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 16.5px;
  margin-bottom: 10px;
  .floating {
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(100% - 30px);
    padding: 20px 21px 15px 11px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.15);
    font-size: 0;
    .info {
      .leftbox {
        display: inline-block;
        width: 30px;
        vertical-align: top;
        margin-top: 5px;
        margin-right: 15px;
        .img {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: url("images/infoicon.png") no-repeat center center;
          background-size: cover;
        }
      }
      .rightbox {
        display: inline-block;
        width: calc(100% - 45px);
        .receiverName {
          font-size: 16px;
          color: #000000;
          line-height: 16px;
          margin-bottom: 5px;
          .phone {
            display: inline-block;
            font-size: 14px;
            color: #808080;
            margin-left: 9px;
            line-height: 20px;
            vertical-align: text-bottom;
          }
        }
        .shop_hours{
          font-size: 12px;
          color: #808080;
          margin-top: 2px;
        }
        .address {
          font-size: 14px;
          color: #000000;
          line-height: 18px;
        }
      }
    }
    .freight {
      padding-top: 15px;
      margin-top: 15px;
      border-top: 0.01rem solid #eeeeee;
      .leftbox {
        display: inline-block;
        width: 30px;
        vertical-align: top;
        margin-top: 5px;
        margin-right: 15px;
        .img {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: url("images/wuliuicon.png") no-repeat center center;
          background-size: cover;
        }
      }
      .rightbox {
        display: inline-block;
        width: calc(100% - 45px);
        .freightCompany {
          font-size: 14px;
          color: #000000;
          line-height: 14px;
          margin-bottom: 10px;
          .phone {
            display: inline-block;
            margin-left: 10px;
            font-size: 14px;
            color: #808080;
            line-height: 14px;
          }
        }
        .freightNumber {
          font-size: 14px;
          color: #000000;
          line-height: 14px;
          .Number {
            display: inline-block;
            margin-left: 10px;
            font-size: 14px;
            color: #808080;
            line-height: 14px;
          }
        }
      }
    }
    
  }
  .itemList {
    display: inline-block;
    width: 100%;
    .detailItem {
      width: 100%;
      margin-bottom: 16px;
      .itemImg {
        display: inline-block;
        width: 50px;
        height: 50px;
        border: 0.01rem solid #eeeeee;
        vertical-align: top;
        margin-right: 11px;
      }
      .itemDetail {
        width: calc(100% - 65px);
        // width: 100%;
        display: inline-block;
        .leftPart {
          display: inline-block;
          .itemName {
            width: 160px;
            font-size: 12px;
            line-height: 17px;
            color: #000000;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .specs {
            font-size: 12px;
            color: #bebebe;
          }
        }
        .rightPart {
          float: right;
          text-align: right;
          .price {
            font-size: 13px;
            color: #000000;
          }
          .numb {
            font-size: 13px;
            color: #bebebe;
          }
        }
      }
    }
    .detailItem:last-child {
      padding-bottom: 30px;
      margin-bottom: 16px;
      border-bottom: 0.01rem solid #eeeeee;
    }
  }
  .priceArea {
    display: inline-block;
    width: 100%;
    .freight {
      width: 100%;
      text-align: left;
      font-size: 12px;
      color: #000000;
      line-height: 20px;
      // margin-bottom: 16.5px;
      .price {
        float: right;
        font-size: 12px;
        color: #000000;
      }
    }
    .freight_you{
      background: url("../../../assets/youhui_img.png") no-repeat;
      background-size: 15px;
      padding-left: 20px;
      background-position: 0px 1px;
    }
    .total {
      font-size: 15px;
      color: #c41335;
      line-height: 15px;
      text-align: right;
      .price {
        float: left;
        font-size: 12px;
        color: #000000;
        line-height: 12px;
        margin-top: 2px;
      }
    }
  }
}
// .    <div class="orderDetail">
//       <p class="title">订单信息</p>
//       <p class="orderNumber">订单号<span class="number"></span></p>
//       <p class="orderCreateTime">订单时间<span class="time"></span></p>
//     </div>
.orderDetail {
  width: 100%;
  display: inline-block;
  background: #ffffff;
  padding: 15px;
  margin-bottom: 60px;
  .innertitle {
    font-size: 14px;
    color: #000000;
    text-align: left;
    line-height: 14px;
    margin-bottom: 15px;
  }
  .orderInner {
    font-size: 12px;
    color: #808080;
    line-height: 12px;
    margin-bottom: 10px;
    .in {
      display: inline-block;
      font-size: 12px;
      color: #000000;
      line-height: 12px;
      width: 25%;
    }
    .in_l{
      display: inline-block;width: 75%;line-height: 17px;    word-wrap: break-word;
    }
  }
  .orderInner:last-child {
    margin-bottom: 0;
  }
}
.buttonPart {
  position:fixed;
  background: #ffffff;
  bottom: 0;
  width: 100%;
  height: 50px;
  text-align: right;
  font-size: 0;
  padding: 13px 15px 13px 15px;
  .orderState {
    font-size: 12px;
    line-height: 24px;
    color: #f8b000;
    text-align: left;
  }
  span {
    display: inline-block;
    margin-left: 10px;
    padding: 5px 8.5px 6px 9px;
    font-size: 12px;
    color: #808080;
    line-height: 12px;
    border: 1px solid #808080;
    border-radius: 3px;
  }
.btn_no{
            background: #EEEEEE;
            border: 1px solid #DADADA;
          }
  .active {
    background: #c41335;
    border: 1px solid #c41335;
    color: #ffffff;
  }
  .grey {
    background: #eeeeee;
    border: 1px solid #eeeeee;
    color: #bebebe;
  }
  .red {
    border: 1px solid #c41335;
    color: #c41335;
  }
}
.pay-popup {
  width: 100%;
  .header {
    position: relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    color: #000000;
    font-size: 17px;
    /*background-color: #C41335;*/
    border-bottom: solid #eeeeee 1px;
    box-sizing: border-box;
    .close {
      position: absolute;
      top: 15px;
      left: 15px;
      width: 15px;
      height: 15px;
      padding: 5px;
      background-image: url("../../../assets/icon-pay-close.png");
      background-size: cover;
      background-position: center center;
    }
    .tip {
      position: absolute;
      left: 0px;
      right: 0px;
      text-align: center;
    }
  }
  .pay-money {
    position: relative;
    .money {
      position: relative;
      height: 60px;
      padding-top: 30px;
      line-height: 30px;
      font-size: 25px;
      font-weight: bold;
      color: #c41335;
      text-align: center;
    }
  }
  .pay-type {
    position: relative;
    width: 100%;
    /*top: 30px;*/
    padding-top: 10px;
    height: 190px;
    /*height: 130px;*/
    /*background-color: yellow;*/
    .pay-box {
      position: relative;
      width: 100%;
      height: 60px;
      line-height: 60px;
      /*background-color: #4BAE4F;*/
      .icon {
        position: absolute;
        top: 20px;
        left: 15px;
        width: 20px;
        height: 20px;
      }
      div {
        position: absolute;
        top: 0px;
        left: 50px;
        width: calc(100% - 60px);
        height: 60px;
        line-height: 60px;
        border-bottom: solid #eeeeee 1px;
        box-sizing: border-box;
      }
      .select {
        position: absolute;
        top: 20px;
        right: 15px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .bottom {
    position: relative;
    width: 100%;
    bottom: 0px;
    height: 65px;
    line-height: 65px;
    background-color: #ffffff;
    /*border-top: solid #EEEEEE 1px;*/
    /*box-sizing: border-box;*/
    .apply {
      position: absolute;
      top: 10px;
      left: 15px;
      height: 45px;
      line-height: 45px;
      width: calc(100% - 30px);
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      background-color: #c41335;
      border-radius: 4px;
    }
  }
}
.mask {
  position: fixed;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #000000;
  opacity: 0.4;
  z-index: 1000;
  top: 0;
  left: 0;
}
.makeSure {
  position: fixed;
  top: calc(50% - 120px);
  width: 305px;
  background: #ffffff;
  z-index: 1001;
  left: 0;
  right: 0;
  margin: 0 auto;
  .cssPopTitle {
    height: 45px;
    background: #c41335;
    p {
      text-align: left;
      font-size: 14px;
      color: #ffffff;
      height: 45px;
      line-height: 45px;
      padding-left: 15px;
    }
  }
  .cssPopBody {
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    display: inline-block;
    padding: 55px 34px 40px 34px;
    .cssWranningtext {
      text-align: center;
      // margin-left: 22.5px;
      font-size: 14px;
      color: #000000;
      margin-bottom: 44px;
      .cssWranning {
        display: inline-block;
        padding: 2px 8px 2px 8px;
        line-height: 16.5px;
        width: 19.5px;
        height: 19.5px;
        border-radius: 50%;
        background: #eea332;
        color: #ffffff;
        font-size: 14px;
        margin-right: 8px;
      }
    }

    .form {
      width: 100%;
      padding: 15px 0 0 30px;
      text-align: left;
      .inner {
        width: 100%;
        line-height: 20px;
        margin-bottom: 15px;
        span {
          display: inline-block;
          width: 125px;
          font-size: 12px;
          color: #000000;
          vertical-align: top;
        }
        input,
        textarea {
          color: #000000;
          font-size: 12px;
          width: 150px;
          text-indent: 5px;
          border: 0.01rem solid #dcdfe6;
          border-radius: 4px;
          -webkit-appearance: none;
        }
        input::placeholder,
        textarea::placeholder {
          color: #bdbdbd;
          font-size: 12px;
        }
      }
    }
    .submit {
      text-align: center;
      line-height: 40px;
      .submitBtn {
        display: inline-block;
        font-size: 14px;
        color: #ffffff;
        background: #c41335;
        border-radius: 4px;
        line-height: 14px;
        padding: 8px 15px 9px 15px;
      }
    }
  }
  .sure {
    padding: 39px 34px 40px 34px;
    .bold {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 19px;
      line-height: 18px;
    }
    .sub {
      text-align: center;
      font-size: 14px;
      color: #000000;
      margin-bottom: 40px;
    }
  }
  .cssBottombutton {
    text-align: center;
    font-size: 0;
    .cssButtonCommon {
      background: #c41335;
      font-size: 14px;
      // line-height: 14px;
      color: #ffffff;
      display: inline-block;
      width: 112px;
      height: 45px;
      line-height: 45px;
      // padding: 16px 36px 16px 36px;
      border-radius: 4px;
      margin-left: 10px;
    }
    .white {
      margin-left: 0px;
      font-size: 14px;
      background: #ffffff;
      color: #c41335;
      border: 1px solid #c41335;
    }
  }
}
.change {
  top: calc(50% - 240px);
  .cssPopBody {
    width: 100%;
    border-radius: 4px;
    background: #ffffff;
    display: inline-block;
    padding: 30px 15px 40px 15px;
    .form {
      padding: 0;
      .inner {
        margin-bottom: 25px;
        span {
          font-size: 14px;
          color: #000000;
        }
        input {
          font-size: 14px;
          color: #000000;
        }
      }
    }
    .submit {
      .submitBtn {
        display: inline-block;
        width: 110px;
        font-size: 14px;
        color: #ffffff;
        height: 40px;
        line-height: 40px;
        padding: 0;
      }
      .cancel {
        color: #c41335;
        background: #ffffff;
        border: 1px solid #c41335;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/orderListDetail.vue